import React, { useEffect, useState } from 'react';
import { MapPin, CheckCircle2 } from 'lucide-react';
const NAMES = ['Carlos', 'Diego', 'Andrés', 'Roberto', 'Miguel', 'Fernando', 'Javier', 'Luis', 'Pablo', 'Martín'];
const LOCATIONS = ['Madrid, España', 'Buenos Aires, Argentina', 'Santiago, Chile', 'Montevideo, Uruguay', 'Lima, Perú', 'Bogotá, Colombia', 'CDMX, México', 'Quito, Ecuador'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    location: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomLocation = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
      setCurrentBuyer({
        name: randomName,
        location: randomLocation
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Hide after 4 seconds
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showPopup();
      // Then set interval for subsequent popups (random between 8-12s)
      const interval = setInterval(() => {
        showPopup();
      }, Math.floor(Math.random() * 4000) + 8000);
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-300" data-id="element-58">
      <div className="bg-navy-800 border border-brand-green/30 rounded-xl p-4 shadow-2xl shadow-brand-green/10 flex items-start gap-3 max-w-[300px]" data-id="element-59">
        <div className="bg-brand-green/20 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-60">
          <CheckCircle2 className="w-5 h-5 text-brand-green" data-id="element-61" />
        </div>
        <div data-id="element-62">
          <p className="text-sm text-gray-300" data-id="element-63">
            <span className="font-bold text-white" data-id="element-64">{currentBuyer.name}</span> de{' '}
            {currentBuyer.location} acaba de comprar este producto.
          </p>
          <p className="text-xs text-brand-green mt-1 font-medium" data-id="element-65">
            Hace unos segundos
          </p>
        </div>
      </div>
    </div>;
}